export const roomsEnumMap: {[key: string]: {[key: string]: string}} = {
  'enum.room.bathroom': {
    en: 'Bathroom',
    it: 'Bagno',
    fr: 'Salle de bain',
    de: 'Bad',
  },
  'enum.room.bedroom': {
    en: 'Bedroom',
    it: 'Camera da letto',
    fr: 'Chambre',
    de: 'Schlafzimmer',
  },
  'enum.room.bedroom_insuite_bathroom': {
    en: 'Bedroom with ensuite bathroom',
    it: 'Camera da letto con bagno',
    fr: 'Suite parentale',
    de: 'Schlafzimmer mit Badezimmer',
  },
  'enum.room.twin_flexible_bedroom': {
    en: 'Convertible bedroom',
    it: 'Camera da letto convertibile',
    fr: 'Chambre avec lit convertible',
    de: 'Umwandelbares Schlafzimmer',
  },
  'enum.room.double_flexible_bedroom': {
    en: 'Convertible bedroom',
    it: 'Camera da letto convertibile',
    fr: 'Chambre avec lit convertible',
    de: 'Umwandelbares Schlafzimmer',
  },
};

export const shortBedBathroomTypesEnum: {
  [key: string]: {[key: string]: string};
} = {
  'enum.bed_type.single': {
    en: 'Single',
    it: 'Singola',
    fr: 'Simple',
    de: 'Einzelzimmer',
  },
  'enum.bed_type.double': {
    en: 'Double',
    it: 'Matrimoniale',
    fr: 'Double',
    de: 'Doppelzimmer',
  },
  'enum.bed_type.triple': {
    en: 'Triple',
    it: 'Tripla',
    fr: 'Chambre pour 3 personnes',
    de: 'Dreibettzimmer',
  },
  'enum.bed_type.quadruple': {
    en: 'Quadruple',
    it: 'Quadrupla',
    fr: 'Chambre pour 4 personnes',
    de: 'Vierbettzimmer',
  },
  'enum.bed_type.twin': {
    en: 'Twin',
    it: 'Doppia',
    fr: 'Lits jumeaux',
    de: 'Doppelzimmer mit Einzelbetten',
  },
  'enum.bed_type.flexible': {
    en: 'Convertible double/twin',
    it: 'Convertibile matrimoniale/doppia',
    fr: 'Lit double convertible en lits jumeaux',
    de: 'Doppelzimmer mit umstellbaren Einzelbetten',
  },
  'enum.bathroom_type.ensuite_bath_shower': {
    en: 'Ensuite bathroom',
    it: 'Bagno in camera',
    fr: 'Salle de bains privative',
    de: 'Privates Badezimmer',
  },
  'enum.bathroom_type.ensuite_shower': {
    en: 'Ensuite bathroom',
    it: 'Bagno in camera',
    fr: 'Salle de bains privative',
    de: 'Privates Badezimmer',
  },
  'enum.room.bathroom': {
    en: 'Bathroom',
    it: 'Bagno',
    fr: 'Salle de bains',
    de: 'Badezimmer',
  },
  'enum.bathroom_type.shower': {
    en: 'Bathroom',
    it: 'Bagno',
    fr: 'Salle de bains',
    de: 'Badezimmer',
  },
};

export const shortBedBathroomTypesPluralEnum: {
  [key: string]: {[key: string]: string};
} = {
  'enum.bed_type.single': {
    en: 'Singles',
    it: 'Singole',
    fr: 'Simples',
    de: 'Einzelzimmer',
  },
  'enum.bed_type.double': {
    en: 'Doubles',
    it: 'Matrimoniali',
    fr: 'Doubles',
    de: 'Doppelzimmer',
  },
  'enum.bed_type.triple': {
    en: 'Triples',
    it: 'Triple',
    fr: 'Chambre pour 3 personnes',
    de: 'Dreibettzimmer',
  },
  'enum.bed_type.quadruple': {
    en: 'Quadruples',
    it: 'Quadruple',
    fr: 'Chambre pour 4 personnes',
    de: 'Vierbettzimmer',
  },
  'enum.bed_type.twin': {
    en: 'Twins',
    it: 'Doppie',
    fr: 'Lits jumeaux',
    de: 'Doppelzimmer mit Einzelbetten',
  },
  'enum.bed_type.flexible': {
    en: 'Convertible doubles/twins',
    it: 'Convertibile matrimoniale/doppia',
    fr: 'Lit doubles convertibles en lits jumeaux',
    de: 'Doppelzimmer mit umstellbaren Einzelbetten',
  },
  'enum.bathroom_type.ensuite_shower': {
    en: 'Ensuite bathrooms',
    it: 'Bagni in camera',
    fr: 'Salles de bains privatives',
    de: 'Private Badezimmer',
  },
  'enum.room.bathroom': {
    en: 'Bathrooms',
    it: 'Bagni',
    fr: 'Salles de bains',
    de: 'Badezimmer',
  },
  'enum.bathroom_type.shower': {
    en: 'Bathrooms',
    it: 'Bagni',
    fr: 'Salles de bains',
    de: 'Badezimmer',
  },
  'enum.bathroom_type.ensuite_bath_shower': {
    en: 'Ensuite bathroom',
    it: 'Bagno in camera',
    fr: 'Salle de bains privative',
    de: 'Privates Badezimmer',
  },
};

export const bedBathroomTypesEnum: {[key: string]: {[key: string]: string}} = {
  'enum.bed_type.single': {
    en: 'Single bed',
    it: 'Letto singolo',
    fr: 'Lit simple',
    de: 'Einzelbett',
  },
  'enum.bed_type.double': {
    en: 'Double bed',
    it: 'Letto matrimoniale',
    fr: 'Lit double',
    de: 'Doppelbett',
  },
  'enum.bed_type.bunk': {
    en: 'Bunk bed',
    it: 'Letto a castello',
    fr: 'Lits superposés',
    de: 'Hochbett',
  },
  'enum.bed_type.sofa': {
    en: 'Sofa',
    it: 'Divano',
    fr: 'Canapé',
    de: 'Sofa',
  },
  'enum.bed_type.french': {
    en: 'French bed',
    it: 'Letto alla francese',
    fr: 'Lit d’une place et demi (largeur 1,50m)',
    de: 'Französisches Bett',
  },
  'enum.bed_type.triple': {
    en: 'Triple',
    it: 'Tripla',
    fr: 'Triple',
    de: 'Dreifach',
  },
  'enum.bed_type.quadruple': {
    en: 'Quadruple',
    it: 'Quadrupla',
    fr: 'Quadruple',
    de: 'Vierfach',
  },
  'enum.bed_type.twin': {
    en: 'Twin bed',
    it: 'Letti singoli',
    fr: 'Lits jumeaux',
    de: 'Zwei Einzelbetten',
  },
  'enum.bed_type.flexible': {
    en: 'Convertible double/twin',
    it: 'Convertibile matrimoniale/doppia',
    fr: 'Lit double/jumeaux convertible',
    de: 'Umstellbares Doppelzimmer / Zimmer mit zwei Einzelbetten',
  },
  'enum.bathroom_type.shower': {
    en: 'Shower',
    it: 'Doccia',
    fr: 'Douche',
    de: 'Dusche',
  },
  'enum.bathroom_type.bathtub': {
    en: 'Bathtub',
    it: 'Vasca',
    fr: 'Baignoire',
    de: 'Badewanne',
  },
  'enum.bathroom_type.bath_shower': {
    en: 'Bath & shower',
    it: 'Doccia e vasca',
    fr: 'Bain et douche',
    de: 'Badewanne & Dusche',
  },
  'enum.bathroom_type.ensuite_shower': {
    en: 'Bathroom with shower',
    it: 'Bagno in camera con doccia',
    fr: 'Salle d’eau',
    de: 'Badezimmer mit Dusche',
  },
  'enum.bathroom_type.ensuite_bathtub': {
    en: 'Bathroom with bathtub',
    it: 'Bagno in camera con vasca',
    fr: 'Salle de bain',
    de: 'Badezimmer mit Badewanne',
  },
  'enum.bathroom_type.ensuite_bath_shower': {
    en: 'Bathroom with bath & shower',
    it: 'Bagno in camera con doccia e vasca',
    fr: 'Salle de bain avec douche et baignoire',
    de: 'Badezimmer mit Badewanne & Dusche',
  },
};

export const bedTypes = [
    'enum.bed_type.single',
    'enum.bed_type.double',
    'enum.bed_type.flexible',
    'enum.bed_type.twin',
    'enum.bed_type.triple',
    'enum.bed_type.quadruple',
];
